
import axios from 'axios'
import { cancelPreviousRequest } from '../helper'
const API_URL = process.env.REACT_APP_THEME_API_URL
const UPLOAD_FILE = `${API_URL}/upload-csv`
const UPLOAD_FILE_LIST = `${API_URL}/upload-csv-list`
const UPLOAD_FILE_STATUS = `${API_URL}/upload-csv-status`
const APPROVED_FILE = `${API_URL}/upload-csv-status`
const UPLOAD_UNIVERSAL_FILE_LIST = `${API_URL}/upload-universal-csv-list`
const UPLOAD_COMFILE_LIST = `${API_URL}/upload-com-csv-list`
export const uploadCSv = (query) => {
    return axios.post(UPLOAD_FILE, query).then((d) => d.data)
}
export const uploadFileList = (query) => {
    return axios.get(`${UPLOAD_FILE_LIST}?${query}`).then((d) => d.data)
}
export const uploadUniversalFileList = (query) => {
    const signal = cancelPreviousRequest()
    return axios.get(`${UPLOAD_UNIVERSAL_FILE_LIST}?${query}`, { signal }).then((d) => d.data)
}
export const uploadComFileList = (query) => {
    return axios.get(`${UPLOAD_COMFILE_LIST}?${query}`).then((d) => d.data)
}
export const uploadFileStatus = (query) => {
    return axios.get(`${UPLOAD_FILE_STATUS}${query}`).then((d) => d.data)
}
export const approvedCSv = (query) => {
    return axios.post(APPROVED_FILE, query).then((d) => d.data)
}
